import { Navigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Lock, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

function FullLoader() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
      <Loader2 className="w-6 h-6 text-zinc-600 animate-spin" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

export function RequirePro({ children, feature = "This feature" }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_pro) return children;
  return (
    <div className="min-h-[80vh] grid-texture flex items-center justify-center p-8" data-testid="paywall">
      <div className="max-w-md w-full border border-zinc-800 rounded-sm bg-[#101010] p-8 text-center">
        <div className="w-12 h-12 rounded-sm bg-blue-600/15 border border-blue-600/30 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-5 h-5 text-blue-400" />
        </div>
        <h2 className="font-display text-2xl font-bold tracking-tight mb-2">Subscription feature</h2>
        <p className="font-mono text-[12px] text-zinc-400 mb-6">{feature} requires a paid plan. The free <span className="text-blue-400">Starter</span> tier covers reading &amp; validating XML. Subscribe to unlock QA, Builder, Profiles, Surfaces, Projects and the Submission Pack.</p>
        <Link to="/pricing">
          <Button data-testid="paywall-upgrade-btn" className="w-full rounded-sm bg-blue-600 hover:bg-blue-500 text-white"><Sparkles className="w-4 h-4 mr-2" /> View plans</Button>
        </Link>
      </div>
    </div>
  );
}
